import idx from 'idx';

export const getVoteStats = (opts) => {
  const { presentation={}, revisions=[], participants=[] } = opts;
  const stats = {
    voteCount: 0,
    totalScores: 0,
    totalWeights: 0,
    maxVoteCount: revisions.length * participants.length
  };

  revisions.forEach(rev => {
    const votes = Object.values(rev.votes);

    stats.voteCount += votes.length;

    votes.forEach(vote => {
      const weight = presentation.weight_votes? vote.weight : 1;
      stats.totalScores += vote.score*weight;
      stats.totalWeights += weight;
    });
  });

  stats.averageScore = parseFloat((
    stats.totalWeights > 0? stats.totalScores/stats.totalWeights : 0
  ).toFixed(1));

  return stats;
}

export const validateSubDomain = (subDomain) => {
  if (!subDomain || !/^[a-z]{3,20}$/.test(subDomain)) {
    return 'Your subdomain must have between 3 and 20 lowercase letters';
  }
}


export const getPresentationDataFromForm = (formData) => {
  const presentationData = {
    ...formData,
    logo: idx(formData, _ => _.logo.file),
    colors: formData.use_standard_colors? {} : { primary: formData.custom_primary_color },
    allow_voting: false,
    allow_comments: false
  };

  if (formData.permissions.indexOf('voting') !== -1) {
    presentationData.allow_voting = true;
  }
  if (formData.permissions.indexOf('comments') !== -1) {
    presentationData.allow_comments = true;
  }

  return presentationData;
}



// WEBPACK FOOTER //
// ./presentations/utils.js